import { connect } from 'react-redux';

import { getApplicationDocsUrl } from '../../reducers/analyticsApp';
import Docs from '../../components/docs/Docs';

const mapStateToProps = (state) => {
  return {
    docsUrl: getApplicationDocsUrl(state),
  };
};

export default connect(mapStateToProps)(Docs);
